

export default function OverlappingImages({ images }) {
  return (
    <div className="flex justify-center items-center">
      <div className="relative flex space-x-[-4rem] items-center justify-center">
        <img
          src={images[1].url}
          alt="Left"
          className="w-36 md:w-48 h-72 object-cover rounded-full shadow-lg"
        />

        <img
          src={images[0].url}
          alt="Center"
          className="w-44 md:w-56 object-cover rounded-full shadow-2xl border-white z-10"
        />

        <img
          src={images[2].url}
          alt="Right"
          className="w-36 md:w-48 h-72 object-cover rounded-full shadow-lg"
        />
      </div>
    </div>
  );
}
